import myAPI from './resources'
import config from '../config'
import carbuyservice from "./clients/carBuyService"

export default {
  getAllUsers: async function () {
    return await carbuyservice.get('/user');
  },
  getAllUsersByRole: async function (roleid) {
    return await carbuyservice.get('/user?roleid=' + roleid);
  },
  getUserByID: async function (userid) {
    return await carbuyservice.get('/user/' + userid);
  },
  getAllPermissions: async function () {
    return await carbuyservice.get('/user/permissions');
  },
  create: async function (data) {
    return await carbuyservice.post('/user', data, true);
  },
  update: async function (data) {
    return await carbuyservice.put('/user', data, true);
  },
  import: async function (data) {
    return await carbuyservice.post('/user/import/' + data.userName, data, true);
  }
}



// WEBPACK FOOTER //
// ./src/api/users.js